import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { PAGE_ICONS, PAGE_ROUTES } from 'pages/AnnualUserAccessReview/_const';
import NavCard from '../../components/NavCard';

/**
 * Templated navigation card for Edit Profile functionality for User Access Review Directory
 * @param {object[]} props.staffData list of staff reporting to logged in user
 * @returns navigation card for profile editing
 */
const EditUsersCard = ({ staffData = [], user }) => {
	const history = useHistory();

	return staffData.length > 0 ? (
		<NavCard
			title={'Edit Users'}
			icon={<PAGE_ICONS.EDIT color='secondary' />}
			role={'Administrative'}
			description={'Edit User Profile Information'}
			onClick={() => {
				history.push({
					pathname: PAGE_ROUTES.EDIT,
					state: {
						loggedInUser: user,
					},
				});
			}}
		/>
	) : null;
};

EditUsersCard.propTypes = {
	staffData: PropTypes.arrayOf(PropTypes.object).isRequired,
	user: PropTypes.object.isRequired,
};

export default EditUsersCard;
